import * as React from 'react';
import { AutoCompleteAsync } from 'sha-el-design';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { QuestionnaireStateObjectConnection, QuestionnaireStateObjectEdge } from '../../../schema';
import { questionnaireStateDropdownQuery } from './constants';
import { API_URL, HEADER } from '../../config';
import { AutoCompleteAsyncProps } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';

export class QuestionnaireStateDropdown extends React.Component<Props, {}> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);
  }

  fetch = (name: string) =>
    new Promise<QuestionnaireStateObjectEdge[]>((resolve, reject) => {
      Api.graphql<{ name: string }, { data: { questionnaireStates: QuestionnaireStateObjectConnection } }>(
        API_URL,
        { name },
        questionnaireStateDropdownQuery,
        HEADER,
        (v) => resolve(v.data.questionnaireStates.edges),
        (e) => reject(e),
      );
    })

  render() {
    return (
      <AutoCompleteAsync
        {...this.props}
        mode='single'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<QuestionnaireStateObjectEdge>, 'data'> {
  mode: 'single';
  value: QuestionnaireStateObjectEdge;
  onChange: (value: QuestionnaireStateObjectEdge) => void;
}
